// Imports
import Vue from 'vue'
import Router from 'vue-router'
import { trailingSlash } from '@/util/helpers'
import { authenticationGuard } from '@/auth/authenticationGuard'

import SalesDashboard from '@/views/SalesDashboard'
import SalesTeamDashboard from '@/views/SalesTeamDashboard'
import UserProfile from '@/views/UserProfile'
import Logout from '@/views/Logout'

Vue.use(Router)

var routerSettings = {
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '',
      component: () => import('@/layouts/default/Index'),
      children: [
        {
          name: 'SalesDashboard',
          path: '/',
          component: SalesDashboard,
          props: true,
          beforeEnter: authenticationGuard,
        },
        {
          name: 'SalesTeamDashboard',
          path: '/SalesTeamDashboard',
          component: SalesTeamDashboard,
          props: true,
          beforeEnter: authenticationGuard,
        },
        {
          name: 'UserProfile',
          path: '/Profile',
          component: UserProfile,
          props: true,
          beforeEnter: authenticationGuard,
        },
        {
          name: 'Logout',
          path: '/logout',
          component: Logout,
          props: true,
          beforeEnter: authenticationGuard,
        },
      ],
    },
  ],
}

const router = new Router(routerSettings)

router.beforeEach((to, from, next) => {
  return to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
})

export default router
